export default "__VITE_ASSET__67jwLHZ1__"